<template>
  <FormulateForm v-model="form" :errors="formErrors" :schema="schema" @submit="submitForm" />
</template>
<script>
import moment from 'moment';

export default {
  props: {
    property: {
      type: Object,
      required: true,
    },
    address: {
      type: String,
      required: true,
    },
    propertyTypes: {
      type: Object,
      required: true,
    },
    statusOptions: {
      type: Object,
      required: true,
    },
    roomAmount: {
      type: Object,
      required: true,
    },
    extras: {
      type: Object,
      required: true,
    },
    selectedValues: {
      type: Array,
    },
  },
  data() {
    return {
      form: this.selectedValues ?? {
        propertyType: 'flat',
        squareMetres: this.property.built_area,
        reformYear: this.property.built_year,
      },
      formErrors: null,
    };
  },
  computed: {
    addressField() {
      return {
        name: 'address',
        type: 'text',
        readonly: true,
        value: this.address,
      };
    },
    propertyTypeField() {
      return {
        name: 'propertyType',
        type: 'radio',
        class: 'formulate-input--inline',
        label: 'Tipo de inmueble',
        options: this.propertyTypes,
      };
    },
    squareMetresField() {
      return {
        name: 'squareMetres',
        type: 'number',
        label: 'Superficie en m²',
        placeholder: 'Superficie',
      };
    },
    remodelingYearField() {
      return {
        name: 'reformYear',
        type: 'number',
        label: 'Año de la última reforma',
        placeholder: 'Año',
        validation: 'min:1600|max:' + moment().year(),
        'validation-messages': {
          min: 'El año no puede ser inferior a 1600.',
          max: 'El año no puede ser superior al actual.',
        },
      };
    },
    statusField() {
      return {
        name: 'status',
        type: 'triotecaSelect',
        class: 'input-select',
        label: 'Estado de conservación',
        placeholder: 'Selecciona una opción',
        options: this.statusOptions,
      };
    },
    roomsField() {
      return {
        name: 'bedrooms',
        type: 'triotecaSelect',
        class: 'input-select',
        label: 'Número de habitaciones',
        placeholder: 'Selecciona una opción',
        options: this.roomAmount,
      };
    },
    bathroomsField() {
      return {
        name: 'bathrooms',
        type: 'triotecaSelect',
        class: 'input-select',
        label: 'Número de baños',
        placeholder: 'Selecciona una opción',
        options: this.roomAmount,
      };
    },
    extrasField() {
      return {
        name: 'extras',
        type: 'checkbox',
        class: 'formulate-input--tag',
        label: 'Extras',
        options: this.extras,
      };
    },
    backButton() {
      return {
        component: 'a',
        class: 'btn btn-ghost btn-lg',
        children: 'Volver',
        '@click': this.back,
      };
    },
    submitButton() {
      return {
        type: 'submit',
        name: 'submit',
        label: 'Continuar',
      };
    },
    buttons() {
      return {
        component: 'div',
        class: 'btn-container',
        children: [this.backButton, this.submitButton],
      };
    },
    schema() {
      return [
        this.addressField,
        this.propertyTypeField,
        this.squareMetresField,
        this.remodelingYearField,
        this.statusField,
        this.roomsField,
        this.bathroomsField,
        this.extrasField,
        this.buttons,
      ];
    },
  },
  methods: {
    submitForm() {
      this.$emit('nextStep', this.form);
    },
    back() {
      this.$emit('prevStep');
    },
  },
};
</script>
